import type { Envelope, Meta } from './envelope.js';

export interface PageOpts {
  limit?: number;
  cursor?: string;
  page?: number;
}

export interface PageMeta extends Meta {
  count?: number;
  next_cursor?: string | null;
  prev_cursor?: string | null;
  total?: number;
  page?: number;
  page_size?: number;
}

export interface Page<T> {
  data: T[];
  meta?: PageMeta;
}

export function buildPageQuery(opts: PageOpts | undefined): Record<string, string | number | undefined> {
  if (!opts) return {};
  const q: Record<string, string | number | undefined> = {};
  if (opts.limit !== undefined) q.limit = opts.limit;
  if (opts.cursor !== undefined) q.cursor = opts.cursor;
  if (opts.page !== undefined) q.page = opts.page;
  return q;
}

export async function* paginate<T>(
  fetcher: (cursor: string | undefined) => Promise<Page<T>>
): AsyncGenerator<T, void, void> {
  let cursor: string | undefined = undefined;
  for (;;) {
    const page: Page<T> = await fetcher(cursor);
    for (const item of page.data) yield item;
    const next = page.meta?.next_cursor;
    if (!next) return;
    cursor = next;
  }
}

export function unwrap<T>(env: Envelope<T>): T {
  return env.data;
}
